import { Maybe } from "../models/common/generic-types";

export function firstLetterUppercase(value?: Maybe<string>) {
	return value && `${value.slice(0, 1).toUpperCase()}${value.slice(1).toLowerCase()}`;
}

export function onlyFirstLetterUppercase(value?: Maybe<string>) {
	return value && `${value.slice(0, 1).toUpperCase()}${value.slice(1)}`;
}
